(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hg-installation-authorization"]) return;
  try {
    
(function () {
  var f = document.getElementById('contact_form');
  if (!f || !f.closest('.hg-auth')) return;
  var accept = document.getElementById('hg-accept');
  var risk = document.getElementById('hg-risk');
  var surfaces = document.getElementById('hg-surfaces');
  var order = document.getElementById('hg-order');
  var orderParam = new URLSearchParams(location.search).get('order');
  if (orderParam && /^#?HG[0-9]+$/i.test(orderParam) && !order.value) order.value = orderParam.replace(/^#/, '').toUpperCase();
  var approve = document.getElementById('hg-approve');
  approve.disabled = false;
  f.addEventListener('submit', function (event) {
    [accept, risk, surfaces].forEach(function (field) { field.setCustomValidity(''); });
    var button = event.submitter;
    if (!button || !button.dataset.decision) { event.preventDefault(); return; }
    var isApproval = button.dataset.decision === 'APPROVE AND AUTHORIZE';
    if (isApproval) {
      if (!accept.checked) accept.setCustomValidity(accept.dataset.validation);
      if (surfaces.value.trim() && !risk.checked) risk.setCustomValidity(risk.dataset.validation);
      if (risk.checked && !surfaces.value.trim()) surfaces.setCustomValidity(surfaces.dataset.validation);
    }
    if (!f.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (surfaces.value.trim() || risk.checked) surfaces.closest('details').open = true;
      f.reportValidity();
      return;
    }
    document.getElementById('hg-terms-status').value = isApproval && accept.checked ? accept.value : 'NOT ACCEPTED';
    document.getElementById('hg-surface-status').value = isApproval && risk.checked ? risk.value : 'NOT ACCEPTED';
    document.getElementById('hg-time').value = new Date().toISOString();
  }, true);
  [accept, risk, surfaces].forEach(function (field) {
    field.addEventListener('input', function () { [accept, risk, surfaces].forEach(function (item) { item.setCustomValidity(''); }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-jersey-configurator"] && !Shopify.designMode) return;
  try {
    
(() => { const root=document.querySelector('[data-hg-jersey]');if(!root)return;const field=id=>root.querySelector('#hg-'+id);const form=root.querySelector('form');const update=()=>{const q=Number(field('quantity').value);const size=field('size').value;const plus=size==='2XL'?'2XL':size==='3XL'?'3XL':size==='4XL'?'4XL':['5XL','6XL','7XL'].includes(size)?'5XL-7XL':'None';field('plus').value=plus;const days=q<=50?2:q<=200?3:q<=500?4:q<=1000?5:q<=1500?9:q<=2000?10:q<=3000?15:null;field('production').value=days?days+' business days after approved print-ready files':'Schedule to be confirmed';const summary=q+' × '+size+' | '+field('design').value+' | '+field('pre').value+' | PMS: '+field('pms').value+' | '+field('delivery').value;root.querySelector('[data-hg-summary]').textContent=summary;field('quote-summary').value=summary;const ref=q===11&&plus==='None'&&!field('breakdown').value.trim()&&field('design').value==='No Proof, Run As Is'&&field('pre').value==='No Proof,Run As Is'&&field('pms').value==='No'&&field('delivery').value==='Pickup in store';root.querySelector('[data-hg-reference]').hidden=!ref;root.querySelector('[data-hg-pending]').hidden=ref;field('delivery-notes').required=field('delivery').value==='Blind Drop Ship';};form.addEventListener('input',update);form.addEventListener('change',update);form.addEventListener('submit',update);update();})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-uv-trading-review"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-uv-review]').forEach(form => {
    if(form.dataset.uvReady) return;
    const find = name => form.querySelector('[data-uv-'+name+']');
    const pack=find('pack'), method=find('method'), front=find('front'), back=find('back'), reorder=find('reorder'), notes=find('notes');
    if(!pack || !pack.options.length) return;
    form.dataset.uvReady='true';
    const price=()=>{find('price').textContent=pack.selectedOptions[0].dataset.price;};
    const artwork=()=>{
      const isReorder=method.value==='Unchanged reorder', combined=method.value==='Combined print-ready front and back', separate=method.value==='Separate print-ready front and back';
      find('front-wrap').hidden=isReorder;front.disabled=isReorder;front.required=combined||separate;
      find('back-wrap').hidden=isReorder||combined;back.disabled=isReorder||combined;back.required=separate;
      find('reorder-wrap').hidden=!isReorder;reorder.disabled=!isReorder;reorder.required=isReorder;
      notes.required=method.value==='Design assistance';
    };
    find('price-wrap').hidden=false;
    pack.addEventListener('change',price);method.addEventListener('change',artwork);
    window.addEventListener('pageshow',()=>{price();artwork();});
    price();artwork();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
